const DOMAIN_NAME = "https://api.updeed.co";
// const DOMAIN_NAME = "https://stage.updeed.co";
// const DOMAIN_NAME = "http://localhost:8080";

export const GET_GRATITUTDE_POSTS_URL = `${DOMAIN_NAME}/api/v1/updeeds/gratitudeposts_v2`;
export const GET_POST_BY_ID_URL = `${DOMAIN_NAME}/api/v1/updeeds/post`;
export const GET_COMMENTS_BY_ID_URL = `${DOMAIN_NAME}/api/v1/updeeds/comments`;
export const GET_USER_PROFILE_BY_ID_URL = `${DOMAIN_NAME}/api/v1/updeeds/user/##user_id##/publicProfile`;
export const UNSUBSCRIBE_NOTIFICATIONS = `${DOMAIN_NAME}/api/v1/updeeds/notifications/unsubscribe`;